module.exports = __webpack_public_path__ + "img/16l012-09.157fa212.jpg";